import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  Button,
  TablePagination,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import axios from 'axios';
import clientConfig from '../../../client-config';

const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [editedCategories, setEditedCategories] = useState({});

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(
        `${clientConfig.backendHOST}/video/videoKategoria`,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'x-auth-token': localStorage.token,
          },
        }
      );
      setCategories(response.data);
    } catch (error) {
      console.error('Hiba történt a kategóriák betöltésekor:', error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleInputChange = (id, field, value) => {
    setEditedCategories((prev) => ({
      ...prev,
      [id]: { ...prev[id], [field]: value },
    }));
  };

  const handleSave = async (id) => {
    try {
      const updatedCategory = {
        ...categories.find((cat) => cat.kategoriaId === id),
        ...editedCategories[id],
      };
      await axios.put(
        `${clientConfig.backendHOST}/video/videoKategoria`,
        updatedCategory,
        {
          headers: {
            'Content-Type': 'application/json',
            'x-auth-token': localStorage.token,
          },
        }
      );
      fetchCategories();
    } catch (error) {
      console.error('Hiba történt a mentéskor:', error);
    }
  };

  return (
    <Box p={3} display='flex' flexDirection='column' alignItems='center'>
      <Typography variant='h4' gutterBottom>
        Kategóriák szerkesztése
      </Typography>
      <Paper
        sx={{
          width: '80%',
          overflow: 'hidden',
          textAlign: 'center',
          padding: '20px',
        }}
      >
        {categories
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row) => (
            <Accordion
              key={row.kategoriaId}
              sx={{ width: '100%', marginBottom: 1 }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant='h6'>{row.kategoriaNev}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <TextField
                  label='Kategória neve'
                  defaultValue={row.kategoriaNev}
                  onChange={(e) =>
                    handleInputChange(
                      row.kategoriaId,
                      'kategoriaNev',
                      e.target.value
                    )
                  }
                  fullWidth
                  variant='filled'
                  margin='dense'
                />
                <TextField
                  label='Vimeo könyvtár'
                  defaultValue={row.vimeoFolder}
                  onChange={(e) =>
                    handleInputChange(
                      row.kategoriaId,
                      'vimeoFolder',
                      e.target.value
                    )
                  }
                  fullWidth
                  variant='filled'
                  margin='dense'
                />
                <TextField
                  label='Fő kép mappa'
                  defaultValue={row.cldImageName}
                  onChange={(e) =>
                    handleInputChange(
                      row.kategoriaId,
                      'cldImageName',
                      e.target.value
                    )
                  }
                  fullWidth
                  variant='filled'
                  margin='dense'
                />
                <TextField
                  label='Sorrend'
                  variant='filled'
                  defaultValue={row.sortOrder}
                  onChange={(e) =>
                    handleInputChange(
                      row.kategoriaId,
                      'sortOrder',
                      e.target.value
                    )
                  }
                  fullWidth
                  margin='dense'
                />
                <TextField
                  label='Leírás'
                  defaultValue={row.kategoriaDescr}
                  onChange={(e) =>
                    handleInputChange(
                      row.kategoriaId,
                      'kategoriaDescr',
                      e.target.value
                    )
                  }
                  fullWidth
                  multiline
                  variant='filled'
                  sx={{ width: '100%', height: '100%' }}
                  rows={5}
                  margin='dense'
                />
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => handleSave(row.kategoriaId)}
                  sx={{ marginTop: 2 }}
                >
                  Mentés
                </Button>
              </AccordionDetails>
            </Accordion>
          ))}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component='div'
          count={categories.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Box>
  );
};

export default Categories;
